import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locales/en.json";
import arTranslation from "./locales/ar.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  ar: {
    translation: arTranslation,
  },
};

const rawStoredLang = localStorage.getItem("lang") || "en";
const normalizedLng = rawStoredLang.toLowerCase().startsWith("ar")
  ? "ar"
  : "en";

i18n.use(initReactI18next).init({
  resources,
  lng: normalizedLng,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
